module.exports = __webpack_public_path__ + "static/media/loyalty_PhoneOrEmail.dd84f5b6.png";